import * as types from '../../mutation_types';

const state = {
    pr_draft_page:1,
    pr_draft_currentpage:5,
    pr_request_page:1,
    pr_request_currentpage:5,
    pr_page:1,
    pr_currentpage:5,
    po_my_orders_page:1,
    po_my_orders_currentpage:5,
    po_page:1,
    po_currentpage:5
};
const getters = {
    pr_draft_page:state=>state.pr_draft_page,
    pr_draft_currentpage:state=>state.pr_draft_currentpage,
    pr_request_page:state=>state.pr_request_page,
    pr_request_currentpage:state=>state.pr_request_currentpage,
    pr_page:state=>state.pr_page,
    pr_currentpage:state=>state.pr_currentpage,
    po_my_orders_page:state=>state.po_my_orders_page,
    po_my_orders_currentpage:state=>state.po_my_orders_currentpage,
    po_page:state=>state.po_page,
    po_currentpage:state=>state.po_currentpage
};
const actions = {

};
const mutations = {
    [types.PR_DRAFT_PAGE](state,data){
        state.pr_draft_page = data;
    },
    [types.PR_DRAFT_CURRENTPAGE](state,data){
        state.pr_draft_currentpage = data;
    },
    [types.PR_REQUEST_PAGE](state,data){
        state.pr_request_page = data;
    },
    [types.PR_REQUEST_CURRENTPAGE](state,data){
        state.pr_request_currentpage = data;
    },
    [types.PR_PAGE](state,data){
        state.pr_page = data;
    },
    [types.PR_CURRENTPAGE](state,data){
        state.pr_currentpage = data;
    },
    [types.PO_MY_ORDERS_PAGE](state,data){
        state.po_my_orders_page = data;
    },
    [types.PO_MY_ORDERS_CURRENTPAGE](state,data){
        state.po_my_orders_currentpage = data;
    },
    [types.PO_PAGE](state,data){
        state.po_page = data;
    },
    [types.PO_CURRENTPAGE](state,data){
        state.po_currentpage = data;
    }
}

export {
    state,
    getters,
    actions,
    mutations
}